import {mainQuery} from '@github-ui/react-core/future/main-query'
import {issuesAppBuilder} from '../config/app-builder'
import {ISSUES_DASHBOARD_PATH} from '../constants/routes'
import type {IssuesDashboardLayoutPayload} from '../types/routes-types'

export const issuesDashboardSurfaceLayoutRoute = issuesAppBuilder.createQueryRouteConfig(
  'issuesDashboardSurfaceLayoutRoute',
  {
    path: ISSUES_DASHBOARD_PATH,
    queries: [
      mainQuery<IssuesDashboardLayoutPayload>({
        queryDeps: ({pathname}) => ({pathname: `${pathname}/_layout`}),
        staleTimeForNavigation: 360000,
      }),
    ],
  },
)
